
import { defineComponent, nextTick } from "vue";

export default defineComponent({
  name: "Popup",
  props: {
    title: String,
    description: String,
    show: Boolean
  },
  emits: ["close"],
  data: () => ({
    isDragging: false,
    dragDelta: 0,
    startDrag: 0
  }),
  computed: {
    dragStyle(): { transform?: string } {
      if (this.isDragging && this.dragDelta) {
        return {
          transform: `translateY(${Math.abs(this.dragDelta)}px)`
        };
      }
      return {};
    }
  },
  methods: {
    popupTouchStartHandler(event: TouchEvent) {
      this.dragDelta = 0;
      this.startDrag = event.changedTouches[0].clientY;
      this.isDragging = true;
    },
    popupTouchMoveHandler(event: TouchEvent) {
      const top = event.changedTouches[0].clientY;
      if (this.isDragging) {
        this.dragDelta = top - this.startDrag > 0 ? top - this.startDrag : 0;
      }
    },
    async popupTouchStopHandler(event: TouchEvent) {
      const top = event.changedTouches[0].clientY;
      if (this.isDragging) {
        this.dragDelta = top - this.startDrag > 0 ? top - this.startDrag : 0;
        this.startDrag = 0;
      }
      this.isDragging = false;
      const popupWindow = this.$refs.popupWindow as HTMLElement;
      if (popupWindow && popupWindow.clientHeight / 2 < this.dragDelta) {
        await nextTick();
        this.dragDelta = 0;
        this.$emit("close");
      }
    }
  }
});
